module.exports = __webpack_public_path__ + "img/40_38_035_360.c76c4548.jpg";